import { Link } from "react-router-dom";
import { ScanText, ScanSearch, GraduationCap, Images, Image } from "lucide-react";
import AppLayout from "@/components/AppLayout";
import Seo from "@/components/Seo";
import { useI18n } from "@/context/I18nContext";

const MODES = [
  { to: "/lens/text", icon: ScanText, bg: "bg-mint", key: "textLens",
    desc: "Translate difficult passages, understand vocabulary and grammar." },
  { to: "/lens/object", icon: ScanSearch, bg: "bg-peach", key: "objectLens",
    desc: "Discover what something is called and learn the language around it." },
  { to: "/lens/scene", icon: Image, bg: "bg-sky", key: "sceneLens",
    desc: "See the whole scene — describe it, count things and learn the language around it." },
  { to: "/lens/study", icon: GraduationCap, bg: "bg-lavender", key: "studyLens",
    desc: "Turn real-world reading into comprehension practice." },
];

export default function FluentLens() {
  const { t } = useI18n();
  return (
    <AppLayout>
      <Seo title="FluentLens · Point. Understand. Learn." />
      <div className="max-w-3xl mx-auto" data-testid="fluentlens-home">
        <div className="mb-8">
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl">Fluent<span className="text-coral">Lens</span></h1>
          <p className="text-gray-600 text-lg mt-1">{t("lens.tagline")}</p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {MODES.map((m) => (
            <Link key={m.to} to={m.to} data-testid={`lens-mode-${m.key.replace("Lens", "").toLowerCase()}`}
              className={`nb-card ${m.bg} p-5 hover:-translate-y-1 transition-transform flex flex-col`}>
              <m.icon className="w-9 h-9 stroke-[2]" />
              <div className="font-cabinet font-extrabold text-2xl mt-3">{t(`lens.${m.key}`)}</div>
              <p className="text-sm mt-3 flex-1">{t(`lensDesc.${m.key.replace("Lens", "")}`)}</p>
            </Link>
          ))}
        </div>

        <Link to="/lens/archive" data-testid="lens-archive-link"
          className="nb-card p-4 mt-5 flex items-center gap-3 hover:-translate-y-0.5 transition-transform">
          <Images className="w-6 h-6" />
          <div><div className="font-bold">{t("lens.home")} {t("lens.archive")}</div><div className="text-xs text-gray-500">{t("lensDesc.archiveSub")}</div></div>
        </Link>
      </div>
    </AppLayout>
  );
}
